

export const getHelpLink = (name) => {
    return `/api/help_link/${name}`
}

export default {
    getHelpLink
}